export const unitSynonyms = [
  'Unit',
  'Apt',
  'Apartment',
  'Suite',
  'Flat',
  '#',
  'Number',
]
